import { Link } from "react-router-dom";

export default function HotTags({ tags }: { tags: string[] }) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
      <h3 className="font-bold text-foreground-950 flex items-center gap-2 mb-4">
        <i className="ri-price-tag-3-line text-accent-600" />
        热门标签
      </h3>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <Link
            key={tag}
            to={`/search?q=${encodeURIComponent(tag)}`}
            className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            #{tag}
          </Link>
        ))}
      </div>
    </div>
  );
}